import type { CookieConsentConfig } from "vanilla-cookieconsent";

export const config: CookieConsentConfig = {
  guiOptions: {
    consentModal: {
      layout: "bar inline",
      position: "bottom",
      equalWeightButtons: true,
      flipButtons: false,
    },
    preferencesModal: {
      layout: "box",
      position: "right",
      equalWeightButtons: true,
      flipButtons: false,
    },
  },
  categories: {
    necessary: {
      readOnly: true,
    },
    analytics: {},
  },
  language: {
    default: "hr",
    autoDetect: "browser",
    translations: {
      hr: {
        consentModal: {
          title: "Politika kolačića",
          description:
            "Lumen@home koristi kolačiće kako bi omogućio rad aplikacije te kako bi skupljali statistike korištenja s kojim poboljšavamo iskustvo korištenja aplikacije.",
          closeIconLabel: "",
          acceptAllBtn: "Prihvati sve",
          acceptNecessaryBtn: "Odbaci sve",
          showPreferencesBtn: "Upravljanje postavkama",
          footer:
            '<a href="/politika-privatnosti">Politika privatnosti</a>\n<a href="/cookie-policy">Politika kolačića</a>',
        },
        preferencesModal: {
          title: "Consent Preferences Center",
          closeIconLabel: "Zatvori",
          acceptAllBtn: "Prihvati sve",
          acceptNecessaryBtn: "Odbaci sve",
          savePreferencesBtn: "Spremi promjene",
          serviceCounterLabel: "Servisi",
          sections: [
            {
              title: "Korištenje kolačića",
              description:
                "Kolačić je kratak tekst koji web stranica šalje vašem pregledniku. Web stranica putem kolačića pamti vaše radnje i željene postavke (prijava, sadržaj košarice, veličina fonta i druge postavke povezane s izgledom) tijekom duljeg razdoblja. Svi kolačići imaju datume isteka koji određuju koliko dugo ostaju u vašem pregledniku. Kolačiće možete kontrolirati u bilo kojem trenutku, što znači da ih možete obrisati. ",
            },
            {
              title:
                'Tehnički kolačići <span class="pm__badge">Uvijek omogućeni</span>',
              description:
                "Svrha tehničkih kolačića je omogućiti ispravno i učinkovito funkcioniranje web stranice i zapamtiti vaš unos kako bi se olakšalo korištenje web stranice. Ako se tehnički kolačići onemoguće, web stranica će otežano funkcionirati. Iz tog razloga ih nije dopušteno onemogućiti.",
              linkedCategory: "necessary",
            },
            {
              title: "Statistički kolačići",
              description:
                "Svrha statističkih kolačića je prikupljati informacije o tome kako posjetitelj posjećuje web stranicu.",
              linkedCategory: "analytics",
            },
            {
              title: "Više informacija",
              description:
                'Za više informacija posjetite našu stranicu <a class="cc__link" href="/cookie-policy">Politika kolaćića</a>.',
            },
          ],
        },
      },
    },
  },
  disablePageInteraction: true,
};
